module.exports = __webpack_public_path__ + "img/footer-1-2.d862febd.png";